import React from 'react';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import View from './View';
import { useApexAdminPortalStateContext, useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import { submitInvestigationResource, setInvestigationResource, refreshInvestigationResource } from '../../ApexAdminPortalActions';

const Investigation = () => {
  const { investigationResource } = useApexAdminPortalStateContext();
  const dispatch = useApexAdminPortalDispatchContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Investigation Details' });

  const onClickRefresh = async () => {
    await refreshInvestigationResource(investigationResource, dispatch, () => {
      displaySuccess('Refreshed Investigation');
    });
    logEvent('Click Refresh');
  };

  if (!investigationResource) {
    return null;
  }
  return (
    <View
      sourceId={investigationResource.id()}
      source={investigationResource.attr('dataSources')}
      reasons={investigationResource.attr('reason') || []}
      notes={investigationResource.attr('notes')}
      setNotes={value => investigationResource.attr('notes', value)}
      onSaveInvestigation={() => {
        submitInvestigationResource(investigationResource, dispatch)
          .then(() => displaySuccess('Saved Notes'))
          .catch(err => displayErrorMessage(err, err.errors));
        logEvent('Click Save Note');
      }}
      onClose={() => setInvestigationResource(null, dispatch)}
      onClickRefresh={onClickRefresh}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

export default Investigation;
